import React from "react";
import { motion } from "framer-motion";
import { Radio, GitBranch, Target, CheckCircle2 } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const icons = [Radio, GitBranch, Target, CheckCircle2];

export const CycleDiagram = () => {
  const { t } = useLang();
  const steps = t.home.cycle;

  return (
    <div className="grid gap-px bg-cool-dark border border-cool-dark md:grid-cols-4" data-testid="cycle-diagram">
      {steps.map((s, i) => {
        const Icon = icons[i];
        return (
          <motion.div
            key={s.k}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.12 }}
            className="bg-nb-base p-7 relative group"
            data-testid={`cycle-step-${s.k.toLowerCase()}`}
          >
            <div className="flex items-center justify-between mb-5">
              <span className="font-mono text-xs text-cool-mid">0{i + 1}</span>
              <Icon size={20} className="text-cyan" strokeWidth={1.6} />
            </div>
            <h3 className="font-display text-xl text-white mb-2">{s.k}</h3>
            <p className="text-sm text-cool-light leading-relaxed">{s.d}</p>
            {i < steps.length - 1 && (
              <span className="hidden md:block absolute top-1/2 -right-px w-2 h-px bg-cyan" />
            )}
          </motion.div>
        );
      })}
    </div>
  );
};
